import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatExcelDate, formatMoney, formatMoneyShorten, isNapaLocationValid } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdArrowBack, MdArrowForward, MdCheck, MdCheckCircle, MdSms, MdWarning, MdWhatsapp } from "react-icons/md";
import * as XLSX from "xlsx";

export default function MultipleStudentsRegistrationForm({ classroomData, classroomUuid, classroomStreams = [], registrationCallback, suggestedStreamUuid = '' }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	

	
	/* Classroom and Stream information */
	const [streamUuid, setStreamUuid] = useState("");

	/* Registrations steps tracker */
	const [isRegSuccessful, setIsRegSuccessful] = useState(false);

	
	function handleExcelTemplateDownload () {
    // Headers in the exact order you provided
    const headers = [
      "Student's First Name",
      "Student's Middle Name",
      "Student's Last Name",
      "Student's Gender",
      "Student's Birth Date",
      "Parent's First Name",
      "Parent's Middle Name",
      "Parent's Last Name",
      "Parent's Gender",
      "Parent's Phone"
    ];

    // Create worksheet with only headers
    const worksheet = XLSX.utils.aoa_to_sheet([headers]);

    // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, "Students_Reg_SSID_Template.xlsx");
  }

	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	function resetForm() {
		
		setStreamUuid('');


		//clear files
		document.getElementById('_excelSheet').value = '';
		
	}

	async function registerStudent() {
		const _excelSheet = document.getElementById('_excelSheet').files[0];
		const studentsJson = await validateExcelSheet();
		
		if(studentsJson !== false && Array.isArray(studentsJson)) {
			if(
				(classroomData.applyStreams === 'yes' && streamUuid) ||
				(classroomData.applyStreams === 'no')
			) {
				setLoading(true);
				await callApi(
					'register-students-in-bulk',
					{
						studentsJson: JSON.stringify(studentsJson),
						classroomUuid,
						streamUuid,
						schoolUuid: appContext.currentSchoolUuid,
					}
				).then(response => {
					if(response.status === 1) {
						setIsRegSuccessful(true);
						resetForm();
						
						if(registrationCallback) {
							registrationCallback()
						}

						appContext.tellMessage("Registration successful");

					} else {
						appContext.tellError(response.msg);
					}
				})
				setLoading(false);
			} else {
				appContext.tellError("Please select stream")
			}
		} else {
			//appContext.tellError("Please fix errors on the sheet");
		}
	}

	/*
	function validateExcelSheet() {
		let _isSheetValid = true;

		const _excelSheet = document.getElementById("_excelSheet").files[0];

		if (_excelSheet) {
			const reader = new FileReader();

			reader.onload = (evt) => {
				const data = new Uint8Array(evt.target.result);
				const workbook = XLSX.read(data, { type: "array" });

				const sheetName = workbook.SheetNames[0];
				const worksheet = workbook.Sheets[sheetName];
				const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

				if (rows.length < 2) {
					_isSheetValid = false;
					appContext.tellError("Excel sheet is empty or missing rows");
				}

				// remove header row
				rows.shift();

				for (let i = 0; i < rows.length; i++) {
					const row = rows[i];

					const studentGender = (row[3] || "").toString().trim().toLowerCase();
					const parentGender = (row[8] || "").toString().trim().toLowerCase();
					const parentPhone = (row[9] || "").toString().trim();

					if (studentGender !== "male" && studentGender !== "female") {
						_isSheetValid = false;
						appContext.tellError(
							`Invalid Student Gender at row ${i + 2}. Allowed: male or female`
						);
						break;
					}

					if (parentGender !== "male" && parentGender !== "female") {
						_isSheetValid = false;
						appContext.tellError(
							`Invalid Parent Gender at row ${i + 2}. Allowed: male or female`
						);
						break;
					}

					if (!/^255\d{9}$/.test(parentPhone)) {
						_isSheetValid = false;
						appContext.tellError(
							`Invalid Parent Phone at row ${i + 2}. Format: 255XXXXXXXXX`
						);
						break;
					}
				}

				
			};

			reader.readAsArrayBuffer(_excelSheet);
		} else {
			_isSheetValid = false;
			appContext.tellError("Invalid Excel Sheet");
		}

		return _isSheetValid;
	}*/

	function validateExcelSheet() {
		return new Promise((resolve) => {
			const _excelSheet = document.getElementById("_excelSheet").files[0];
			if (!_excelSheet) {
				appContext.tellError("Invalid Excel Sheet");
				resolve(false); // ✅ always resolve a Promise
				return;
			}

			const reader = new FileReader();

			reader.onload = (evt) => {
				const data = new Uint8Array(evt.target.result);
				const workbook = XLSX.read(data, { type: "array" });

				const sheetName = workbook.SheetNames[0];
				const worksheet = workbook.Sheets[sheetName];
				const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: true, });

				if (rows.length < 2) {
					appContext.tellError("Excel sheet is empty or missing rows");
					resolve(false);
					return;
				}

				// remove header row
				rows.shift();

				const students = [];
				let isValid = true;

				for (let i = 0; i < rows.length; i++) {
					const row = rows[i];

					const student = {
						firstName: String(row[0] || "").trim(),
						middleName: String(row[1] || "").trim(),
						lastName: String(row[2] || "").trim(),
						gender: String(row[3] || "").toLowerCase().trim(),
						birthDate: String(formatExcelDate(row[4]) || "").trim(),
						parentFirstName: String(row[5] || "").trim(),
						parentMiddleName: String(row[6] || "").trim(),
						parentLastName: String(row[7] || "").trim(),
						parentGender: String(row[8] || "").toLowerCase().trim(),
						parentPhone: String(row[9] || "").trim(),
					};

					// validations
					if (student.gender !== "male" && student.gender !== "female") {
						appContext.tellError(
							`Invalid Student Gender at row ${i + 2}. Allowed: male or female`
						);
						isValid = false;
						break;
					}

					if (student.parentGender !== "male" && student.parentGender !== "female") {
						appContext.tellError(
							`Invalid Parent Gender at row ${i + 2}. Allowed: male or female`
						);
						isValid = false;
						break;
					}

					if (!(/^255\d{9}$/.test(student.parentPhone) && student.parentPhone.trim().length === 12)) {
						appContext.tellError(
							`Invalid Parent Phone at row ${i + 2}. Format: 255XXXXXXXXX`
						);
						isValid = false;
						break;
					}

					students.push(student);
				}

				resolve(isValid ? students : false);
			};

			reader.readAsArrayBuffer(_excelSheet);
		});
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		setStreamUuid(suggestedStreamUuid);
	}, [ suggestedStreamUuid ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
		
			<div
				style={{
					width: "100%",
				}}
				id="_studentRegForm2"
			>
				{
					(isRegSuccessful) ?
					<div className="row">
						<div className="col-md-12 text-center">
							<MdCheckCircle size={64}/>
							
							<h6
								className="font-light"
								style={{
									fontSize: "24px"
								}}
							>
								Students Registration was completed
							</h6>

							<button
								className="btn btn-rounded btn-padded btn-outline-dark mt-4 mb-4"
								onClick={() => {
									setIsRegSuccessful(false);
								}}
							>
								Register Again
							</button>
						</div>
					</div>
					:
					<>
						
						
													
						<div className="row">
							<div className="col-md-12 mt-2 mb-2 text-start">

								<h6 
									className="sub-section-title"
									style={{
										marginBottom: "20px"
									}}
								>
									
									Import Excel Sheet
								</h6>

								<div className="card">
									<div className="card-body">

									
								
										<h6
											className="font-light"
											style={{
												fontSize: "16px"
											}}
										>
											<MdWarning size={24} />
											The imported excel file should have columns in the following order:
										</h6>

										<ul>
											<li>Student's First Name</li>
											<li>Student's Middle Name</li>
											<li>Student's Last Name</li>
											<li>Student's Gender (male or female)</li>
											<li>Student's Birth Date</li>
											<li>Parent's First Name</li>
											<li>Parent's Middle Name</li>
											<li>Parent's Last Name</li>
											<li>Parent's Gender (male or female)</li>
											<li>Parent's Phone (with countrycode like 2557XXXXXXXX)</li>
										</ul>
										<h6
											className="font-light"
											style={{
												fontSize: "16px"
											}}
										>
											Click the button below to download the excel template, or contact our support team for assistance
										</h6>

										<div className="text-end">
											<button
												className="btn btn-sm btn-outline-dark"
												onClick={handleExcelTemplateDownload}
											>
												Download Excel Template
											</button>
										</div>
									</div>
								</div>
								
							</div>

							<div className="col-md-12 mt-2 mb-2">
								<label className="form-label">Selected Classroom</label>
								<h6
									style={{
										fontSize: "32px",

									}}
									className="font-light"
								>
									{classroomData.name}
								</h6>
							</div>

							{
								(classroomData.applyStreams === 'yes') ?
								<div className="col-md-12 mt-2 mb-2">
									<label className="form-label">Select Stream</label>
									<select
										className="form-control"
										value={streamUuid}
										onChange={(e) => setStreamUuid(e.target.value)}
										disabled={(suggestedStreamUuid) ? true : false}
									>
										<option value="">Select Stream</option>
										{
											(classroomStreams && classroomStreams.length > 0) ?
											classroomStreams.map((item, i) => {
												return (
													<option key={i} value={item.uuid}>{item.name}</option>
												)
											})
											:""
										}
									</select>
								</div>
								:
								""
							}

							<div className="col-md-12 mt-2 mb-2">
								<label className="form-label">Excel File</label>
								<input
									type="file"
									className="form-control"
									id="_excelSheet"
									accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
								/>

							</div>
							

							<div className="col-md-12 mt-2 mb-2">
								<hr/>
								
							</div>
						</div>
						
						<div className="row">
							

							<div className="col-md-12 mt-2 mb-2 text-center">
								

								<button
									className="btn btn-padded btn-block btn-secondary btn-rounded btn-padded"
									onClick={registerStudent}
								>
									Submit & Register Students
								</button>
							</div>

							

							
						</div>
							
					</>
				}
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}